import { makeStyles } from '@material-ui/core';
import { edekaColors } from '../../theme/edekaColors';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    height: 36,
  },
  mark: {
    width: 32,
    height: 32,
    flexShrink: 0,
  },
  wordmark: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.05,
  },
  brand: {
    fontFamily: 'EDEKAHead-Black, Helvetica, Arial, sans-serif',
    fontSize: 20,
    color: edekaColors.white,
    letterSpacing: 0.5,
  },
  subtitle: {
    fontFamily: 'EDEKAText-Regular, Helvetica, Arial, sans-serif',
    fontSize: 11,
    color: edekaColors.yellow,
    fontWeight: 400,
  },
});

/** Sidebar logo (open): EDEKA badge + wordmark. */
export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root} aria-hidden>
      <svg
        className={classes.mark}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="64" height="64" rx="8" fill={edekaColors.yellow} />
        <path
          fill={edekaColors.blueActive}
          d="M14 14h36v8H24v8h26v8H24v8h26v8H14V14z"
        />
      </svg>
      <div className={classes.wordmark}>
        <span className={classes.brand}>EDEKA</span>
        <span className={classes.subtitle}>Developer Portal</span>
      </div>
    </div>
  );
};
